import $ from 'jquery';

/*
 * Order
 */

// resize on collapse items list
$('#order-items').on('hidden.bs.collapse shown.bs.collapse', function () {
    $(window).trigger('resize');
});

// add items to order
$('#create-item')
    .on('start.create.row', function (e) {
        $(e.target).fragment('block');
        const fragments = $('#order-items, #order-total');
        if (!fragments.length) {
            $('#order').className('toggle').find('.checkout').fragment('block');
        } else {
            fragments.fragment('block');
        }
    })
    .on('error.create.row', function (e) {
        // FIXME
        //$(e.target).message('show');
        window.alert('No podés agregar productos en este momento.');
        window.location.reload();
    })
    .on('finish.create.row', function (e) {
        $(e.target).fragment('load');
        const fragments = $('#order-items, #order-total');
        if (!fragments.length) {
            $('#order').find('.checkout').fragment('load');
        } else {
            fragments.fragment('load');
        }
    });

// if there is no items in the order, hide order container
$(document).on('blank.fragment', '#order-items', function (e) {
    $('#order')
        .find('[data-target="#order-items"]').attr('aria-expanded', false).end()
        .find('.checkout').fragment('load').end()
        .className('toggle');
});

// update items list and total on order modifications
$(document)
    .on('start.update.row start.delete.row', '.item', function (e) {
        $('#create-item, #order-items, #order-total, #checkout-review, #checkout-confirm, #checkout-comment').fragment('block');
    })
    .on('error.update.row', '.item', function (e) {
        alert('No podés modificar productos en este momento.');
        window.location.reload();
    })
    .on('finish.update.row finish.delete.row', '.item', function (e) {
        $('#create-item, #order-items, #order-total, #checkout-review, #checkout-confirm, #checkout-comment').fragment('load');
    });


/*
 * Checkout
 */

$(document)
    .on('start.create.row start.delete.row', '.preference', function (e) {
        $('#checkout-shipping, #checkout-review, #checkout-payment, #checkout-confirm, #checkout-comment').fragment('block');
    })
    .on('error.create.row error.delete.row', '.preference', function (e) {
        $(e.relatedTarget).message('show');
    })
    .on('finish.create.row finish.delete.row', '.preference', function (e) {
        $('#checkout-shipping, #checkout-review, #checkout-payment, #checkout-confirm, #checkout-comment').fragment('load');
    })
    .on('loaded.fragment', '#checkout-shipping', function (e) {
        $('.preference a[data-toggle="popover"], .metadata a[data-toggle="popover"]').popover();
        $('.modal[data-tooggle="auto"]').modal('show')
    });

$(document).on('success.update.row', '#checkout-comment-form', function (e) {
    $('#checkout-confirm').fragment('load');
});

$('.preference a[data-toggle="popover"], .metadata a[data-toggle="popover"]').popover();

$('#checkout-coupon')
    .on('start.create.row start.delete.row', '.metadata', function (e) {
        $('#checkout-review, #checkout-confirm, #checkout-coupon').fragment('block');
    })
    .on('error.create.row error.delete.row', '.metadata', function (e) {
        $(e.relatedTarget).message('show');
    })
    .on('finish.create.row finish.delete.row', '.metadata', function (e) {
        $('#checkout-review, #checkout-confirm, #checkout-coupon').fragment('load');
    })

$(document)
    .on('error.create.row', '.transfer', function (e) {
        $(e.relatedTarget).message('show');
    })
    .on('finish.create.row', '.transfer', function (e) {
        window.location.reload();
    });

$('#order').on('toggl', function (e) {
    if (e.relatedTarget && e.relatedTarget.classList.contains('modify-order')) {
        e.target.classList.add('review');
    }

    function handler(e) {
        if ($(e.target).closest('#order').length) {
            return;
        }
        $('#order.review').className('remove');
        $(e.target).off('click', handler);
    }
    $('body').on('click', handler);
});

$(function () {
    $('#order-modal').modal()
    $('#payment-help').find('[data-toggle="popover"]').popover({
        html: true,
        content: function () {
            return '<img class="img-fluid" src="' + $(this).data('img') + '" />';
        },
    });
});

$(document).on('restored.value', '#checkout-comment-text', function (e) {
    $(e.target).addClass('show');
});

$(function () {
    $('.mercadopago-button').click()
    $('#mercadopago-form').submit()
});

$(document).on("cut copy paste", ".noPaste", function (e) {
    e.preventDefault();
});

$(document).on('change', 'select[id*="user-address-province"]', function (e) {
    const form = $(this).closest('form').serializeArray()
    var data = {}
    $(form).each(function (index, element) {
        data[element.name] = element.value
    })
    $(this).closest('[data-fragment]').fragment('post', data)
})

$(document).on('slide.bs.carousel', '.user-address-carousel', function (e) {
    const $item = $(e.relatedTarget)
    const $form = $item.closest('form')
    if (!$form.get(0).reportValidity()) {
        return false
    }
    if ($item.is('[data-name="map"]')) {
        const street = $form.find('input[name="street"]').val()
        const number = $form.find('input[name="number"]').val()
        const locality = $form.find('select[name="locality_id"] option:selected').text()
        const province = $form.find('select[name="province_id"] option:selected').text()
        const address = `${street} ${number}, ${locality}, ${province}`
        $item.find('.user-address-map').addressMap({ address: address })
    }
})

$(document).on('location.addressMap', '.user-address-map', function (e) {
    const $form = $(this).closest('form')
    $form.find('input[name="lat"]').val(e.latLng.lat())
    $form.find('input[name="lng"]').val(e.latLng.lng())
})

$(document).on('click', 'a[data-toggle="geolocation"]', function (e) {
    e.preventDefault()
    const $target = $($(this).data('target'))
    if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(position => {
            $target.addressMap('setPosition', { lat: position.coords.latitude, lng: position.coords.longitude })
        })
    } else {
        alert('El navegador que estás usando no permite obtener tu ubicación.')
    }
})

$(document).on('finish.create.row finish.update.row', '.modal form[action="address"]', function () {
    $(this).find('.carousel').carousel('next')
})

$(document).on('hidden.bs.modal', '.user-address-modal', function () {
    if (!$(this).find('.carousel-item.active').is('[data-name="success"]')) {
        return
    }
    if (window.location.pathname == '/user-profile' || window.location.pathname == '/perfil') {
        const action = $(this).is('#user-address-create-modal') ? 'user-address-create' : 'user-address-update';
        const $form = $('<form method="post" action="" />')
        $form.append(`<input type="hidden" name="action" value="${action}" />`)
        $form.append('<input type="hidden" name="return[done]" value="perfil" />')
        $form.append('<input type="hidden" name="return[fail]" value="perfil" />')
        $form.appendTo($('body'))
        $form.trigger('submit')
    } else {
        $('#checkout-shipping, #checkout-review, #checkout-payment, #checkout-confirm').fragment('load')
    }
})

$('.modal[data-tooggle="auto"]').each(function () {
    $(this).modal('show')
})

$('.btn-delete-address').click(function () {
    let prefixField = 'user-address-delete-id';
    let item = $('#' + prefixField);
    let id = $(this).data('id');
    $(item).val(id);
});

$(document).on('click', 'a[data-history="back"]', function (e) {
    e.preventDefault();
    window.history.back();
});

$(function () {
    $('[data-toggle="tooltip"]').tooltip()
})